import React from 'react';

const ProjectBanner = ({ project }) => {
  const bannerImage = project.detailBanner || project.banner;
  
  // Determine background position based on project ID
  let backgroundPosition = 'center 25%'; // Default position
  
  // Use a different position for CustomBedwars project
  if (project.id === 'customBedwars') {
    backgroundPosition = 'center 50%'; // Adjusted position for CustomBedwars
  }

  if (project.id === 'pluginCommission') {
    backgroundPosition = 'center 70%'; // Adjusted position for CustomBedwars
  }
  
  // Fallback to a default banner if the image is missing
  const backgroundStyle = bannerImage ? 
    { 
      backgroundImage: `url(${bannerImage.startsWith('/') ? process.env.PUBLIC_URL + bannerImage : `${process.env.PUBLIC_URL}/${bannerImage}`})`,
      backgroundPosition: backgroundPosition
    } : 
    { backgroundColor: '#294C6F' };

  
  return (
    <div 
      className="h-[32rem] w-full bg-cover -mt-24 relative"
      style={backgroundStyle}
    >
      {/* Add back the semi-transparent overlay with blur and saturation effects */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm saturate-50"></div>
      
      {/* Text content with its own background to ensure readability */}
      <div className="text-center relative pt-56 z-10">
        <h1 className="text-6xl font-bold text-white mb-10 drop-shadow-lg text-shadow-lg">
          {project.title}
        </h1>
        <p className="text-xl text-white font-semibold mb-1 drop-shadow-md text-shadow-md">
          {project.role}
        </p>
        {project.startDate && (
          <p className="text-lg text-white/80 drop-shadow-md text-shadow-sm">
            {project.startDate} - {project.endDate || "Present"}
          </p>
        )}
      </div>
    </div>
  );
};

export default ProjectBanner; 